import { CONFIRM_WITHDRAWAL } from "./actions.type";
import { SET_WITHDRAWAL_ERROR } from "./mutations.type";
import ApiService from "@/common/api.service";
const initialState = {
  errors: {}
};
export const state = { ...initialState };

export const actions = {
  [CONFIRM_WITHDRAWAL]({ commit }, payload) {
    return ApiService.patch(`v1/customers/withdrew_at/${payload}`, {})
      .then(() => {})
      .catch(() => {
        commit(SET_WITHDRAWAL_ERROR, response.data);
      });
  }
};

const getters = {};

/* eslint no-param-reassign: ["error", { "props": false }] */
export const mutations = {
  [SET_WITHDRAWAL_ERROR](state, payload) {
    state.errors = payload;
  }
};
export default {
  state,
  actions,
  getters,
  mutations
};
